import clsx from "clsx";
import type { FC } from "react";

import { t } from "i18n/i18n";
import { Listbox } from "mds/components/Listbox";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";

export type SectionViewOption = "course" | "term";

export type SectionViewOptionMenuProps = {
  selectedOption: SectionViewOption;
  onOptionChange: (option: SectionViewOption) => void;
  eventPrefix?: string;
};

const OPTIONS: { id: SectionViewOption; title: string }[] = [
  { id: "course", title: t("glossary.course") },
  { id: "term", title: t("glossary.term") },
];

export const SectionViewOptionMenu: FC<SectionViewOptionMenuProps> = ({
  selectedOption,
  onOptionChange,
  eventPrefix = "",
}) => {
  const isSmallScreen = !useIsMdOrLarger();

  return (
    <Listbox
      buttonSize="s"
      buttonText={selectedOption === "course" ? t("home.view_by_course") : t("home.view_by_term")}
      className={clsx("justify-between", isSmallScreen ? "w-full" : "w-[206px]")}
      eventName={`${eventPrefix}Course view option selected`}
      eventPropertyKey="fieldValue"
      items={OPTIONS}
      selectedValue={selectedOption}
      onSelectionChange={(item) => onOptionChange(item.id)}
    />
  );
};
